import React, { useEffect, useRef, useState } from "react";
import "./ScrollReveal.css";

const ScrollReveal = ({ children, className = "", delay = 0, style = {} }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (!("IntersectionObserver" in window)) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -40px 0px"
      }
    );

    observer.observe(el);

    return () => {
      if (el) {
        observer.unobserve(el);
      }
    };
  }, []);

  const combinedStyle = {
    ...style,
    transitionDelay: delay ? `${delay}ms` : undefined,
  };

  return (
    <div
      ref={ref}
      className={`scroll-reveal ${isVisible ? "is-visible" : ""} ${className}`}
      style={combinedStyle}
    >
      {children}
    </div>
  );
};

export default React.memo(ScrollReveal);
